(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slider-con-modal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById('slider');
  const items = document.querySelectorAll('.slider-item');
  const modal = document.getElementById('fabricModal');
  const closeBtn = modal.querySelector('.modal-close');

  items.forEach(item => {
    item.addEventListener('click', () => {
      document.getElementById('modal-title').innerText = item.dataset.title;
      document.getElementById('modal-desc').innerText = item.dataset.desc;
      document.getElementById('modal-img-top').src = item.dataset.imgTop;
      document.getElementById('modal-img-bottom').src = item.dataset.imgBottom;
      document.getElementById('modal-limpieza').innerHTML = item.dataset.limpieza;
      modal.classList.add('open');
    });
  });

  closeBtn.addEventListener('click', () => {
    modal.classList.remove('open');
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.classList.remove('open');
    }
  });

  window.scrollSlider = function (dir) {
    slider.scrollBy({
      left: dir * slider.offsetWidth,
      behavior: 'smooth'
    });
  };
});

  } catch(e) { console.error(e); }
})();
})();
